/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import { isClientPortalUserAuthenticated } from "../auth/authentication";

const clientPortalAuthSlice = createSlice({
  name: "isClientPortalUserAuthenticated",
  initialState: isClientPortalUserAuthenticated() as boolean,
  reducers: {
    setIsClientPortalUserAuthenticated: (_, action) => action.payload
  }
});

export const { setIsClientPortalUserAuthenticated } = clientPortalAuthSlice.actions;
export default clientPortalAuthSlice.reducer;
